<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<div class="DispositionsContainer w-100 h-100" *ngIf="dataLoadSuccess && !noData" id="dispositions-widget">
    <div class="grid-container d-flex flex-column" *ngIf="moduleState.view === 'table'">
        <div *ngIf="!noData" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
            <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()"
                class="cxone-widget-search" name="cxoneInput-{{moduleKey}}" (ngModelChangeDebounced)="filterValue"
                [ngModelChangeDebounceTime]="500"></cxone-text-input>
            <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>

        <div *ngIf="dataLoadSuccess && !noData && gridOptions !== null" class="table-container">
            <cxone-grid class="content-container" id="dispositions-grid" [gridOptions]="gridOptions"></cxone-grid>
        </div>
    </div>

    <div *ngIf="moduleState.view === 'chart'" class="chartContainer w-100 d-flex flex-column">
        <highcharts-chart *ngIf="chartConfig" (chartInstance)="setChartInstance($event)" [Highcharts]="highcharts"
            [options]="chartConfig" class="w-100 h-100"></highcharts-chart>
    </div>

    <div class="combinationView" *ngIf="moduleState.view === 'table_and_chart'">
        <div class="halfPanel d-flex flex-column position-relative">
            <div *ngIf="!noData" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
                <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()"
                    class="cxone-widget-search" name="cxoneInput-{{moduleKey}}" (ngModelChangeDebounced)="filterValue"
                    [ngModelChangeDebounceTime]="500"></cxone-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>

            <div *ngIf="dataLoadSuccess && !noData && gridOptions !== null" class="flex-fill table-container">
                <cxone-grid class="content-container" id="dispositions-grid" [gridOptions]="gridOptions"></cxone-grid>
            </div>
        </div>

        <div class="panelDivider"></div>

        <div class="halfPanel">
            <highcharts-chart *ngIf="chartConfig" (chartInstance)="setChartInstance($event)" [Highcharts]="highcharts"
                [options]="chartConfig" class="w-100 h-100"></highcharts-chart>
        </div>
    </div>
</div>